import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import { optimumFrictionConstants } from "../../../../_redux/_constants/optimumFriction.constants";
import {
     optimumFrictionClearTrainingImport,
     optimumFrictionCommitTrainingImportRequest,
} from "../../../../_redux/_actions";
import { toCommitRows } from "../optimumFrictionTrainingRow";
import OptimumFrictionAccreditationImport from "./views/OptimumFrictionAccreditationImport";
import OptimumFrictionAccreditationResults from "./views/OptimumFrictionAccreditationResults";
import OptimumFrictionImportHistoryGrid from "./views/OptimumFrictionImportHistoryGrid";

// The Renault Academy file is read in the browser and sent to the backend, which decides what each
// row means and reports it back row by row. There is no separate check step: every rule lives in
// the backend, so a check here would only be a second opinion that could disagree with it.
export default function OptimumFrictionAccreditationWrapper() {
     const actionDispatch = useDispatch();

     const importResult = useSelector(
          (state) => state?.optimumFriction?.trainingImportResult,
     );

     const pendingRequests = useSelector(
          (state) => state?.loading?.pendingRequests || [],
     );
     // True from the moment the batch is sent until the result comes back, so the import button
     // cannot be pressed a second time and grant everybody twice.
     const isImporting = pendingRequests.includes(
          optimumFrictionConstants.OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_REQUEST,
     );

     const [submittedRows, setSubmittedRows] = useState([]);

     useEffect(() => {
          return () => {
               actionDispatch(optimumFrictionClearTrainingImport());
          };
     }, [actionDispatch]);

     const onImport = useCallback(
          (rows, fileName) => {
               setSubmittedRows(toCommitRows(rows));
               actionDispatch(
                    optimumFrictionCommitTrainingImportRequest({
                         rows: toCommitRows(rows),
                         fileName,
                    }),
               );
          },
          [actionDispatch],
     );

     const done = useCallback(() => {
          actionDispatch(optimumFrictionClearTrainingImport());
     }, [actionDispatch]);

     return (
          <>
               <MainLeftTitle title="Optimum Friction Training Accreditation" />

               <div className="sba-telerik-components-wr">
                    {/* Either the file being checked or the outcome is on screen, never both. */}
                    {importResult ? (
                         <OptimumFrictionAccreditationResults
                              result={importResult}
                              rows={submittedRows}
                              onDone={done}
                         />
                    ) : (
                         <>
                              <OptimumFrictionAccreditationImport
                                   isImporting={isImporting}
                                   onImport={onImport}
                              />

                              {/* The history sits under the picker, as the LCV upload screens
                                  have it, and refreshes itself once a run has finished. */}
                              <OptimumFrictionImportHistoryGrid />
                         </>
                    )}
               </div>
          </>
     );
}
